/* Atelier Elemental -- the scent wardrobe (Sean 2026-10-16).
 * Hanger buttons (product page + product cards), header hanger count, the wardrobe page
 * (/pages/wardrobe) and the home-page "welcome back" shelf.
 *
 * Saving: signed-in customers save to their account through the app proxy
 * (/apps/rewards/wardrobe -> AE-Inventory-Adjuster wardrobe.js). Guests save on this device
 * (localStorage) and their wardrobe is merged into the account the first time we see them signed
 * in; the device copy is only cleared after the server confirms the merge.
 * Config + all wording come from snippets/ae-wardrobe-config.liquid (window.__AEW).
 * Never emails, never adds anything to the bag without a tap, no countdowns, no fake scarcity.
 */
(function () {
  'use strict';
  var C = window.__AEW;
  if (!C || window.__AEW_LOADED) return;
  window.__AEW_LOADED = true;
  var S = C.s || {};
  var LS_KEY = 'ae-wardrobe-v1', LOOK_KEY = 'ae-look', TIP_KEY = 'aew-tip', NUDGE_KEY = 'aew-nudge', CACHE_KEY = 'aew-cache';
  var LOOKS = ['walnut', 'marble', 'sage'];

  // ---------- small helpers ----------
  function t(key, vars) {
    var s = S[key] == null ? key : String(S[key]);
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('%%' + k + '%%').join(vars[k]); });
    return s;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function money(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
      return new Intl.NumberFormat(C.fr ? 'fr-CA' : 'en-CA', { style: 'currency', currency: cur, minimumFractionDigits: 2 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sizeLabel(title) {
    var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*ml/i);
    return m ? m[1] + (C.fr ? ' ml' : ' mL') : String(title || '');
  }
  function sizeMl(title) { var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*ml/i); return m ? parseFloat(m[1].replace(',', '.')) : 0; }
  function date(ms) {
    try { return new Intl.DateTimeFormat(C.fr ? 'fr-CA' : 'en-CA', { month: 'short', day: 'numeric' }).format(new Date(ms)); } catch (e) { return ''; }
  }
  function monthYear(ms) {
    try { return new Intl.DateTimeFormat(C.fr ? 'fr-CA' : 'en-CA', { month: 'long', year: 'numeric' }).format(new Date(ms)); } catch (e) { return ''; }
  }
  // "TERRE D'HERMES EDT DECANT" by "Hermès" -> "Terre D'Hermes EDT"
  function niceTitle(title, vendor) {
    var s = String(title || '').replace(/\s+(decant|décant)s?\s*$/i, '').trim();
    if (vendor) {
      var v = String(vendor).trim();
      if (s.toUpperCase().indexOf(v.toUpperCase() + ' ') === 0 && s.length > v.length + 2) s = s.slice(v.length + 1);
    }
    if (s === s.toUpperCase()) {
      s = s.toLowerCase().replace(/(^|[\s\-'’(])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); })
        .replace(/\b(Edp|Edt|Edc)\b/g, function (m) { return m.toUpperCase(); })
        .replace(/\b([DL])(['’])/g, function (m, a, b) { return a.toLowerCase() + b; });
    }
    return s;
  }

  // ---------- state ----------
  // st = { items:[{p,h,s,a}], look, collected:[{p,h,n,at,s}], hidden:[], notify:[{p,vid}], back:[], signedIn }
  var local = lsGet(LS_KEY) || { items: [], look: null };
  var cache = lsGet(CACHE_KEY);
  var st = {
    items: (cache && cache.signedIn ? cache.items : local.items) || [],
    look: lsGet(LOOK_KEY) || (cache && cache.look) || local.look || 'walnut',
    collected: (cache && cache.collected) || [], hidden: [], notify: (cache && cache.notify) || [], back: (cache && cache.back) || [],
    signedIn: !!(cache && cache.signedIn),
  };
  if (LOOKS.indexOf(st.look) < 0) st.look = 'walnut';
  var listeners = [];
  function changed() { listeners.forEach(function (fn) { try { fn(); } catch (e) {} }); }
  function onChange(fn) { listeners.push(fn); }
  function saveCache() {
    if (st.signedIn) lsSet(CACHE_KEY, { signedIn: true, items: st.items, look: st.look, collected: st.collected.slice(0, 40), notify: st.notify, back: st.back, at: Date.now() });
    else { lsSet(LS_KEY, { items: st.items, look: st.look }); try { localStorage.removeItem(CACHE_KEY); } catch (e) {} }
    lsSet(LOOK_KEY, st.look);
  }
  function has(p) { p = String(p); for (var i = 0; i < st.items.length; i++) if (st.items[i].p === p) return i + 1; return 0; }

  // ---------- server ----------
  function proxyUrl(extra) {
    var u = C.proxy + (C.proxy.indexOf('?') < 0 ? '?' : '&') + 'c=' + encodeURIComponent(C.c || '') + '&t=' + encodeURIComponent(C.t || '');
    return u + (extra || '');
  }
  function serverGet(fresh) {
    return fetch(proxyUrl(fresh ? '&fresh=1' : ''), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  var queue = [], events = [], flushing = false, flushTimer = null;
  function track(kind) { events.push(kind); scheduleFlush(); }
  function scheduleFlush() { clearTimeout(flushTimer); flushTimer = setTimeout(flush, 400); }
  function flush() {
    if (flushing || (!queue.length && !events.length)) return;
    var ops = st.signedIn ? queue.splice(0, queue.length) : [];
    if (!st.signedIn) queue.length = 0;
    var ev = events.splice(0, events.length);
    flushing = true;
    var body = 'payload=' + encodeURIComponent(JSON.stringify({ ops: ops, events: ev })) + '&c=' + encodeURIComponent(C.c || '') + '&t=' + encodeURIComponent(C.t || '');
    fetch(C.proxy, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body, keepalive: true })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, code: r.status, j: j }; }); })
      .then(function (res) {
        flushing = false;
        if (res.code === 401 && st.signedIn) { signedOut(); return; }
        if (res.ok && res.j && res.j.signedIn !== false && res.j.items) adopt(res.j);
        else if (!res.ok && ops.length) { queue = ops.concat(queue); setTimeout(scheduleFlush, 4000); }
        if (queue.length || events.length) scheduleFlush();
      })
      .catch(function () { flushing = false; if (ops.length) { queue = ops.concat(queue); setTimeout(scheduleFlush, 4000); } });
  }
  function adopt(j) {
    st.signedIn = true;
    st.items = j.items || [];
    if (j.look) st.look = j.look;
    st.collected = j.collected || [];
    st.hidden = j.hidden || [];
    st.notify = j.notify || [];
    st.back = j.back || [];
    saveCache(); changed();
  }
  // the account copy stays on the account; this device goes back to its own (guest) wardrobe
  function signedOut() {
    st.signedIn = false; queue.length = 0;
    try { localStorage.removeItem(CACHE_KEY); } catch (e) {}
    st.items = (lsGet(LS_KEY) || {}).items || []; st.collected = []; st.notify = []; st.back = [];
    changed();
  }
  function op(o) {
    if (st.signedIn) { queue.push(o); scheduleFlush(); }
  }

  // ---------- actions ----------
  function hang(p, h, s, silent) {
    p = String(p);
    if (has(p)) { if (s) setSize(p, s); return; }
    st.items.push({ p: p, h: h, s: s || '', a: Date.now() });
    op({ op: 'add', p: p, h: h, s: s || '' }); track('add');
    saveCache(); changed();
    if (!silent) afterHang();
  }
  function setSize(p, s) {
    var it = st.items[has(p) - 1]; if (!it) return;
    it.s = s; op({ op: 'size', p: String(p), s: s }); saveCache(); changed();
  }
  function moveOut(p, name) {
    var i = has(p) - 1; if (i < 0) return;
    var it = st.items.splice(i, 1)[0];
    op({ op: 'remove', p: String(p) }); track('remove');
    saveCache(); changed();
    toast(t('moved_out', { name: esc(name || '') }), t('put_back'), function () {
      st.items.splice(Math.min(i, st.items.length), 0, it);
      op({ op: 'putback', p: it.p, h: it.h, s: it.s, a: it.a, i: i });
      saveCache(); changed();
    });
  }
  function setLook(l) {
    if (LOOKS.indexOf(l) < 0 || l === st.look) return;
    st.look = l; op({ op: 'look', look: l }); track('look'); saveCache(); changed();
  }
  function afterHang() {
    var n = st.items.length;
    if (!st.signedIn && n === 3 && !lsGet(NUDGE_KEY)) {
      lsSet(NUDGE_KEY, 1); track('save_prompt');
      toast(t('nudge_three'), t('save_cta'), function () { track('save_click'); location.href = C.loginUrl; }, 9000);
      return;
    }
    toast(n === 1 ? t('hung_one') : t('hung_n', { n: n }), t('see_it'), function () { location.href = C.wardrobeUrl; });
  }

  // ---------- toast ----------
  var toastEl = null, toastTimer = null;
  function toast(html, actionLabel, action, ms) {
    if (toastEl) toastEl.remove();
    clearTimeout(toastTimer);
    toastEl = document.createElement('div');
    toastEl.className = 'aew-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = '<span>' + html + '</span>';
    if (actionLabel) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = actionLabel;
      b.addEventListener('click', function () { var el = toastEl; toastEl = null; if (el) el.remove(); action && action(); });
      toastEl.appendChild(b);
    }
    document.body.appendChild(toastEl);
    var el = toastEl;
    toastTimer = setTimeout(function () { if (el === toastEl) { el.remove(); toastEl = null; } }, ms || 4500);
  }

  // ---------- product data (theme view: /products/<h>?view=wardrobe) ----------
  var pcache = ssGet('aew-pc') || {};
  var inflight = {}, waiting = [], active = 0;
  function product(h) {
    var c = pcache[h];
    if (c && Date.now() - c.at < 5 * 60 * 1000) return Promise.resolve(c.d);
    if (inflight[h]) return inflight[h];
    inflight[h] = new Promise(function (resolve) {
      waiting.push(function () {
        active++;
        fetch(C.root + 'products/' + encodeURIComponent(h) + '?view=wardrobe', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (txt) { var d = JSON.parse(txt.trim()); pcache[h] = { at: Date.now(), d: d }; ssSet('aew-pc', pcache); resolve(d); })
          .catch(function () { resolve(null); })
          .then(function () { active--; delete inflight[h]; next(); });
      });
      next();
    });
    return inflight[h];
  }
  function next() { while (active < 6 && waiting.length) waiting.shift()(); }
  function avail(d) { return !!(d && d.vars && d.vars.some(function (v) { return v.a; })); }
  function pickVar(d, s) {
    if (!d || !d.vars || !d.vars.length) return null;
    // their size if it's in stock, else the smallest size that is, else their size (shown sold out)
    var exact = d.vars.filter(function (v) { return v.t === s; })[0];
    if (exact && exact.a) return exact;
    return smallest(d) || exact || d.vars[0];
  }
  function smallest(d) {
    var a = (d && d.vars || []).filter(function (v) { return v.a; });
    a.sort(function (x, y) { return (sizeMl(x.t) || 999) - (sizeMl(y.t) || 999); });
    return a[0] || null;
  }

  // ---------- bag ----------
  function addToBag(lines) {
    var items = lines.map(function (l) { return { id: String(l.id), quantity: 1 }; });
    return fetch((C.root || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetch((C.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        lines.forEach(function () { track('bag'); });
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ae-wardrobe', data: { source: 'ae-wardrobe', itemCount: cart.item_count } } })); } catch (e) {}
        refreshCartSections();
        return cart;
      });
  }
  function refreshCartSections() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) { if (/cart|drawer|bubble|header/i.test(el.id)) ids.push(el.id.replace('shopify-section-', '')); });
    var done = function () { ['cart:refresh', 'cart:updated', 'cart-drawer:refresh'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); }); };
    if (!ids.length) return done();
    fetch(location.pathname + '?sections=' + ids.slice(0, 5).join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (data) {
      ids.slice(0, 5).forEach(function (id) {
        var host = document.getElementById('shopify-section-' + id);
        if (!host || !data[id] || /header/i.test(id)) return;
        var doc = new DOMParser().parseFromString(data[id], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        if (fresh) host.innerHTML = fresh.innerHTML;
      });
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (b) { fetch((C.root || '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { b.textContent = c.item_count || ''; }); });
      done(); paintButtons();
    }).catch(done);
  }

  // ---------- hanger buttons + header count ----------
  var HANGER = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8.1 5.6a1.9 1.9 0 1 1 2.95 1.58c-.66.44-1.05.92-1.05 1.62v.3M10 9.1 2.9 14.1c-.5.35-.25 1.1.35 1.1h13.5c.6 0 .85-.75.35-1.1L10 9.1z"/></svg>';
  function paintButtons() {
    document.querySelectorAll('[data-aew-hang]').forEach(function (b) {
      var n = has(b.getAttribute('data-p'));
      b.setAttribute('aria-pressed', n ? 'true' : 'false');
      var big = b.classList.contains('aew-wbtn');
      var lab = b.querySelector('[data-aew-label]');
      if (big && lab) lab.textContent = n ? t('in_wardrobe_no', { n: n }) : t('add_to_wardrobe');
      if (!big) b.setAttribute('aria-label', n ? t('in_wardrobe') : t('add_to_wardrobe'));
      var hint = b.parentNode && b.parentNode.querySelector('[data-aew-hint]');
      if (hint) hint.textContent = n ? t('hint_on') : t('hint_off');
    });
    var count = st.items.length;
    document.querySelectorAll('[data-aew-count]').forEach(function (el) { el.textContent = count ? String(count) : ''; el.hidden = !count; });
  }
  onChange(paintButtons);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aew-hang]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var p = b.getAttribute('data-p'), h = b.getAttribute('data-h');
    var s = '';
    if (b.classList.contains('aew-wbtn')) {
      // product page: remember the size they are looking at
      var form = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      var vars = {}; try { vars = JSON.parse(b.getAttribute('data-vars') || '{}'); } catch (x) {}
      if (form && vars[form.value]) s = vars[form.value];
    }
    if (has(p)) {
      if (b.classList.contains('aew-wbtn')) moveOut(p, b.getAttribute('data-name'));
      else location.href = C.wardrobeUrl;
      return;
    }
    hang(p, h, s, false);
    if (!b.classList.contains('aew-wbtn') && !lsGet(TIP_KEY)) {
      lsSet(TIP_KEY, 1);
      toast(t('first_tip'), t('see_it'), function () { location.href = C.wardrobeUrl; }, 7000);
    }
  }, true);

  // ---------- injected pieces (kept out of the theme's own files so theme updates don't clash) ----------
  // Header hanger beside the bag; product-page button under Add to bag; home-page welcome shelf after the
  // hero. A MutationObserver puts them back when the theme re-renders a section (variant change, cart).
  function injectHeader() {
    document.querySelectorAll('header-actions').forEach(function (ha) {
      if (ha.querySelector('.aew-hicon')) return;
      var cart = ha.querySelector('[aria-controls="cart-drawer"], .action__cart');
      var a = document.createElement('a');
      a.className = 'aew-hicon header-actions__action'; a.href = C.wardrobeUrl; a.setAttribute('aria-label', t('title'));
      a.innerHTML = HANGER + '<span class="aew-badge" data-aew-count hidden></span>';
      if (cart) cart.parentNode.insertBefore(a, cart); else ha.appendChild(a);
    });
  }
  function injectPdp() {
    var d = C.pdp; if (!d) return;
    var host = document.querySelector('.buy-buttons-block'); if (!host || host.querySelector('.aew-pdp')) return;
    var div = document.createElement('div'); div.className = 'aew-pdp';
    div.innerHTML = '<button type="button" class="aew-wbtn" data-aew-hang data-p="' + esc(d.p) + '" data-h="' + esc(d.h) + '" data-name="' + esc(d.name) + '" aria-pressed="false">' + HANGER + '<span data-aew-label></span></button><p class="aew-whint" data-aew-hint></p>';
    div.querySelector('button').setAttribute('data-vars', JSON.stringify(d.vars || {}));
    var form = host.querySelector('product-form-component');
    if (form && form.nextSibling) host.insertBefore(div, form.nextSibling); else host.appendChild(div);
  }
  function injectWelcome() {
    if (!C.home || document.getElementById('aew-welcome')) return;
    var main = document.getElementById('MainContent'); if (!main) return;
    var first = main.querySelector('.shopify-section');
    var w = document.createElement('div'); w.id = 'aew-welcome'; w.className = 'aew-welcome'; w.hidden = true;
    if (first && first.nextSibling) main.insertBefore(w, first.nextSibling); else main.appendChild(w);
  }
  var injTimer = null;
  function inject() { injectHeader(); injectPdp(); injectWelcome(); paintButtons(); }
  inject();
  try { new MutationObserver(function () { clearTimeout(injTimer); injTimer = setTimeout(function () { var miss = Array.prototype.some.call(document.querySelectorAll('header-actions'), function (h) { return !h.querySelector('.aew-hicon'); }); if (miss || (C.pdp && !document.querySelector('.aew-pdp'))) inject(); }, 120); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  // ---------- the card (charcoal, double gold rule, filigree corners) ----------
  var ORN = '<svg class="aew-cn %%c%%" viewBox="0 0 40 40" aria-hidden="true"><path d="M5 5h22M5 5v22M9 9h11M9 9v11"/><path d="M20 9c5 0 8 3 6 6.5-1.6 2.6-5.6 1.4-4.6-1.4.7-1.8 2.7-1.5 3.1-.4"/><path d="M9 20c0 5 3 8 6.5 6 2.6-1.6 1.4-5.6-1.4-4.6-1.8.7-1.5 2.7-.4 3.1"/><path d="M13.5 11.2l2.3 2.3-2.3 2.3-2.3-2.3z" fill="currentColor" stroke="none"/><circle cx="27" cy="5" r="1.2" fill="currentColor" stroke="none"/><circle cx="5" cy="27" r="1.2" fill="currentColor" stroke="none"/></svg>';
  var CORNERS = ['tl', 'tr', 'bl', 'br'].map(function (c) { return ORN.replace('%%c%%', c); }).join('');
  function card(d, alt) {
    var img = d && (d.cut || d.img);
    var cls = 'aew-card' + (d && !d.cut ? ' aew-card--photo' : '') + (d && !avail(d) ? ' aew-card--out' : '');
    return '<span class="' + cls + '">' + CORNERS + (img ? '<img src="' + esc(img) + '" alt="' + esc(alt || '') + '" loading="lazy" decoding="async">' : '') + '</span>';
  }

  // ---------- bottom sheet ----------
  var sheet = null;
  function closeSheet() { if (sheet) { sheet.remove(); sheet = null; document.documentElement.classList.remove('aew-lock'); } }
  function openSheet(entry, d, mode) {
    // mode: 'almost' | 'collected' | 'bigger'
    closeSheet();
    if (!d) return;
    var name = niceTitle(d.t, d.v);
    var item = st.items[has(entry.p) - 1];
    var chosen = mode === 'almost' ? (item && item.s) : entry.s;
    var vars = d.vars.slice().sort(function (a, b) { return (sizeMl(a.t) || 999) - (sizeMl(b.t) || 999); });
    if (mode === 'bigger') {
      var cur = sizeMl(entry.s);
      var up = vars.filter(function (v) { return v.a && sizeMl(v.t) > cur; })[0];
      chosen = up ? up.t : chosen;
    }
    // start on their size only if it's in stock; a sold-out size stays tappable for Notify me
    var pick = vars.filter(function (v) { return v.t === chosen && v.a; })[0] || vars.filter(function (v) { return v.a; })[0] || vars.filter(function (v) { return v.t === chosen; })[0] || vars[0];
    var wrap = document.createElement('div');
    wrap.className = 'aew-sheetwrap';
    wrap.setAttribute('data-look', st.look);
    var owned = mode !== 'almost';
    var ownLine = owned
      ? (entry.s ? t('you_bought', { size: esc(sizeLabel(entry.s)), date: esc(date(entry.at)) }) : t('you_bought_nosize', { date: esc(date(entry.at)) }))
      : t('in_wardrobe_size', { n: has(entry.p) });
    wrap.innerHTML = '<div class="aew-sheet" role="dialog" aria-modal="true" aria-label="' + esc(name) + '">' +
      '<div class="aew-grab"></div><div class="aew-sheet__top">' + card(d, name) +
      '<div><div class="aew-house">' + esc(String(d.v || '').toUpperCase()) + (owned ? ' · ' + esc(t('owned')) : '') + '</div>' +
      '<div class="aew-name aew-name--big">' + esc(name) + '</div><div class="aew-ownline">' + ownLine + '</div></div></div>' +
      '<div class="aew-sizes" role="group" aria-label="' + esc(t('size')) + '"></div>' +
      '<button type="button" class="aew-btn aew-btn--big" data-act="add"></button>' +
      '<div class="aew-sheet__extra"></div>' +
      '<button type="button" class="aew-link" data-act="rm"></button>' +
      '<a class="aew-link" href="' + esc(d.u) + '">' + esc(t('view_product')) + '</a>' +
      '<button type="button" class="aew-link aew-close" data-act="close">' + esc(t('close')) + '</button></div>';
    var sh = wrap.querySelector('.aew-sheet');
    var sz = sh.querySelector('.aew-sizes'), addB = sh.querySelector('[data-act="add"]'), extra = sh.querySelector('.aew-sheet__extra');
    function draw() {
      sz.innerHTML = '';
      vars.forEach(function (v) {
        var b = document.createElement('button'); b.type = 'button';
        b.textContent = sizeLabel(v.t);
        b.setAttribute('aria-pressed', v === pick ? 'true' : 'false');
        if (!v.a) b.classList.add('aew-size--out');
        b.addEventListener('click', function () { pick = v; if (mode === 'almost') setSize(entry.p, v.t); draw(); });
        sz.appendChild(b);
      });
      extra.innerHTML = '';
      if (pick.a) {
        addB.hidden = false;
        var again = owned && entry.s && entry.s === pick.t;
        addB.textContent = (again ? t('buy_again') : t('add_to_bag')) + ' · ' + money(pick.p);
      } else {
        addB.hidden = true;
        var asked = st.notify.some(function (n) { return String(n.vid) === String(pick.id); });
        var nb = document.createElement('button'); nb.type = 'button'; nb.className = 'aew-btn aew-btn--big aew-btn--ghost';
        if (!st.signedIn) { nb.textContent = t('notify_signin'); nb.onclick = function () { location.href = C.loginUrl; }; }
        else if (asked) { nb.textContent = t('notify_on'); nb.disabled = true; }
        else {
          nb.textContent = t('notify_me');
          nb.onclick = function () {
            st.notify.push({ p: String(d.id), vid: String(pick.id) });
            op({ op: 'notify', p: String(d.id), h: d.h, vid: String(pick.id) }); track('notify'); saveCache(); draw();
          };
        }
        var p = document.createElement('p'); p.className = 'aew-small'; p.textContent = t('sold_out_line');
        extra.appendChild(p); extra.appendChild(nb);
      }
    }
    draw();
    addB.addEventListener('click', function () {
      addB.disabled = true;
      if (mode === 'bigger') track('go_bigger');
      addToBag([pick]).then(function () { closeSheet(); toast(t('added_bag', { name: esc(name), size: esc(sizeLabel(pick.t)) })); })
        .catch(function () { addB.disabled = false; toast(t('add_failed')); });
    });
    var rm = sh.querySelector('[data-act="rm"]');
    if (owned) {
      rm.textContent = t('hide_collected');
      rm.addEventListener('click', function () {
        closeSheet();
        st.hidden.push(String(entry.p));
        st.collected = st.collected.filter(function (c) { return String(c.p) !== String(entry.p); });
        op({ op: 'hide', p: String(entry.p) }); saveCache(); changed();
        toast(t('hidden', { name: esc(name) }), t('put_back'), function () { op({ op: 'unhide', p: String(entry.p) }); refresh(true); });
      });
    } else {
      rm.textContent = t('move_out_long');
      rm.addEventListener('click', function () { closeSheet(); moveOut(entry.p, name); });
    }
    sh.querySelector('[data-act="close"]').addEventListener('click', closeSheet);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) closeSheet(); });
    document.addEventListener('keydown', function k(e) { if (e.key === 'Escape') { closeSheet(); document.removeEventListener('keydown', k); } });
    document.body.appendChild(wrap);
    document.documentElement.classList.add('aew-lock');
    sheet = wrap;
    addB.focus({ preventScroll: true });
    if (st.back.indexOf(String(entry.p)) > -1) { st.back = st.back.filter(function (x) { return x !== String(entry.p); }); op({ op: 'seen_back', p: String(entry.p) }); saveCache(); }
  }

  // ---------- cabinet (shared by page + welcome) ----------
  function frame() { return '<span class="aew-fr t"></span><span class="aew-fr b"></span><span class="aew-fr l"></span><span class="aew-fr r"></span>'; }
  function looksSwitch() {
    var names = { walnut: t('look_walnut'), marble: t('look_marble'), sage: t('look_sage') };
    return '<span class="aew-lookname">' + esc(names[st.look]) + '</span><div class="aew-looks" role="group" aria-label="' + esc(t('look_label')) + '">' +
      LOOKS.map(function (l) { return '<button type="button" class="aew-sw aew-sw--' + l + '" data-look="' + l + '" aria-pressed="' + (l === st.look) + '" aria-label="' + esc(names[l]) + '"></button>'; }).join('') + '</div>';
  }

  // ---------- the wardrobe page ----------
  var page = document.getElementById('aew-page');
  var showAllCollected = false, justCollected = [];
  function renderPage() {
    if (!page) return;
    page.setAttribute('data-look', st.look);
    var items = st.items, col = st.collected;
    var first = C.firstName ? esc(C.firstName) : '';
    var since = items.concat(col.map(function (c) { return { a: c.at }; })).reduce(function (m, i) { return i.a && (!m || i.a < m) ? i.a : m; }, 0);
    var html = '';
    html += '<div class="aew-head"><div class="aew-seal">' + (first ? esc(first.charAt(0).toUpperCase()) : HANGER) + '</div><div>' +
      '<div class="aew-eyebrow">' + esc(t('eyebrow')) + '</div><h1 class="aew-h1">' + (first ? t(C.fr && /^[aeiouyhàâéèêëîïôûù]/i.test(C.firstName) ? 'title_named_v' : 'title_named', { name: first }) : esc(t('title'))) + '</h1>' +
      '<div class="aew-since">' + (st.signedIn ? (since ? esc(t('since', { date: monthYear(since) })) : '') : esc(t('device_only'))) + '</div></div></div>';
    if (!st.signedIn) {
      html += '<div class="aew-savebox"><h2 class="aew-h4">' + esc(t('save_title')) + '</h2><p>' + esc(t('save_body')) + '</p>' +
        '<a class="aew-btn aew-btn--big" href="' + esc(C.loginUrl) + '" data-aew-save>' + esc(t('save_cta')) + '</a></div>';
    }
    html += '<div class="aew-cabinet">' + looksSwitch() + frame();
    if (col.length) {
      var row = showAllCollected ? col : col.slice(0, 8);
      html += '<div class="aew-wlabel"><span>' + esc(t('collected_n', { n: col.length })) + '</span></div><div class="aew-shelf aew-shelf--owned' + (showAllCollected ? ' aew-shelf--all' : '') + '">';
      row.forEach(function (c) {
        html += '<button type="button" class="aew-slot aew-slot--own' + (justCollected.indexOf(String(c.p)) > -1 ? ' aew-slot--new' : '') + '" data-col="' + esc(c.p) + '" data-h="' + esc(c.h) + '"><span class="aew-card aew-card--loading">' + CORNERS + '</span>' +
          (c.n > 1 ? '<span class="aew-times">×' + c.n + '</span>' : '') + '<span class="aew-tag">' + esc(t('owned')) + '</span></button>';
      });
      if (!showAllCollected && col.length > 8) html += '<div class="aew-slot aew-slot--more"><button type="button" class="aew-morecard" data-act="allcol"><b>+' + (col.length - 8) + '</b>' + esc(t('more')) + '<br><u>' + esc(t('see_all')) + '</u></button></div>';
      html += '</div><div class="aew-plank"></div>';
    }
    html += '<div class="aew-wlabel"><span>' + esc(t('almost_yours')) + '</span></div>';
    // one wrapping shelf: CSS sets 3 a row on phones, 4 on desktop, short rows centred
    [items].forEach(function (sh) {
      html += '<div class="aew-shelf">';
      sh.forEach(function (it) {
        var n = has(it.p);
        html += '<button type="button" class="aew-slot" data-p="' + esc(it.p) + '" data-h="' + esc(it.h) + '"><span class="aew-card aew-card--loading">' + CORNERS + '</span>' +
          (st.back.indexOf(String(it.p)) > -1 ? '<span class="aew-times aew-times--back">' + esc(t('back_badge')) + '</span>' : '') +
          '<span class="aew-tag">' + esc(t('no_n', { n: n })) + '</span></button>';
      });
      html += '</div><div class="aew-plank"></div>';
    });
    html += '</div>';
    html += '<div class="aew-count"><span>' + (col.length ? t('count_both', { c: col.length, n: items.length }) : t('count_almost', { n: items.length })) + '</span></div>';
    if (!items.length && !col.length) html += '<div class="aew-empty"><p>' + esc(t('empty_body')) + '</p><a class="aew-btn" href="' + esc(C.shopUrl) + '">' + esc(t('empty_cta')) + '</a></div>';
    if (col.length) {
      html += '<h2 class="aew-lhead">' + esc(t('collected_recent')) + '</h2><div class="aew-list" data-list="col">';
      (showAllCollected ? col : col.slice(0, 3)).forEach(function (c) { html += '<div class="aew-item" data-col="' + esc(c.p) + '" data-h="' + esc(c.h) + '"></div>'; });
      html += '</div>';
      if (col.length > 3 && !showAllCollected) html += '<button type="button" class="aew-seeall" data-act="allcol">' + esc(t('see_all_collected', { n: col.length })) + '</button>';
    }
    if (items.length) {
      html += '<h2 class="aew-lhead">' + esc(t('almost_yours')) + '</h2><div class="aew-list" data-list="almost">';
      items.forEach(function (it) { html += '<div class="aew-item" data-p="' + esc(it.p) + '" data-h="' + esc(it.h) + '"></div>'; });
      html += '</div><div class="aew-sticky" hidden><button type="button" class="aew-btn aew-btn--big" data-act="home"></button><p></p></div>';
    }
    page.innerHTML = html;
    fillPage();
  }
  function fillPage() {
    page.querySelectorAll('.aew-slot[data-h]').forEach(function (s) {
      var h = s.getAttribute('data-h');
      product(h).then(function (d) {
        var c = s.querySelector('.aew-card');
        if (!c) return;
        var nm = d ? niceTitle(d.t, d.v) : '';
        c.outerHTML = card(d, nm);
        s.setAttribute('aria-label', nm);
        if (d && !avail(d) && !s.classList.contains('aew-slot--own')) { var tg = s.querySelector('.aew-tag'); if (tg) tg.textContent = t('no_n', { n: has(s.getAttribute('data-p')) }) + ' · ' + t('sold_out'); }
      });
    });
    page.querySelectorAll('.aew-item').forEach(function (row) {
      var h = row.getAttribute('data-h');
      product(h).then(function (d) {
        if (!d) { row.remove(); return; }
        var nm = niceTitle(d.t, d.v);
        if (row.hasAttribute('data-col')) {
          var c = st.collected.filter(function (x) { return String(x.p) === row.getAttribute('data-col'); })[0]; if (!c) return;
          var cur = sizeMl(c.s);
          var bigger = d.vars.some(function (v) { return v.a && sizeMl(v.t) > cur; });
          var v = pickVar(d, c.s);
          row.innerHTML = '<div class="aew-thumb">' + card(d, nm) + '</div><div class="aew-meta"><div class="aew-house">' + esc(String(d.v || '').toUpperCase()) + ' · ' + esc(t('owned')) + '</div>' +
            '<div class="aew-name">' + esc(nm) + '</div><div class="aew-yours">' + (c.s ? t('you_bought', { size: '<em>' + esc(sizeLabel(c.s)) + '</em>', date: esc(date(c.at)) }) : t('you_bought_nosize', { date: esc(date(c.at)) })) + '</div>' +
            '<div class="aew-row"><span class="aew-price">' + (v ? esc(sizeLabel(v.t)) + ' · ' + money(v.p) : '') + '</span>' +
            (avail(d) ? '<button type="button" class="aew-up" data-act="' + (bigger && cur && cur < 10 ? 'bigger' : 'again') + '">' + esc(bigger && cur && cur < 10 ? t('go_bigger') : t('buy_again')) + '</button>' : '<span class="aew-small">' + esc(t('sold_out')) + '</span>') + '</div></div>';
        } else {
          var it = st.items[has(row.getAttribute('data-p')) - 1]; if (!it) return;
          var pv = pickVar(d, it.s);
          var ok = pv && pv.a;
          row.innerHTML = '<div class="aew-thumb">' + card(d, nm) + '</div><div class="aew-meta"><div class="aew-house">' + esc(String(d.v || '').toUpperCase()) + ' · ' + esc(t('no_n', { n: has(it.p) })) + '</div>' +
            '<div class="aew-name">' + esc(nm) + '</div><div class="aew-yours">' + t('yours_since', { date: '<em>' + esc(date(it.a)) + '</em>' }) + (it.s && pv && pv.t === it.s ? ' · ' + t('your_size', { size: esc(sizeLabel(it.s)) }) : '') + '</div>' +
            (st.back.indexOf(String(it.p)) > -1 ? '<div class="aew-backline">' + esc(t('back_line')) + '</div>' : '') +
            '<div class="aew-row"><span class="aew-price">' + (pv ? (ok ? esc(sizeLabel(pv.t)) + ' · ' + money(pv.p) : esc(t('sold_out'))) : '') + '</span><span class="aew-acts"><button type="button" class="aew-out" data-act="out">' + esc(t('move_out')) + '</button>' +
            (ok ? '<button type="button" class="aew-btn" data-act="add">' + esc(t('add')) + '</button>' : '<button type="button" class="aew-btn aew-btn--ghost" data-act="open">' + esc(t('notify_short')) + '</button>') + '</span></div></div>';
        }
        updateSticky();
      });
    });
    updateSticky();
  }
  function updateSticky() {
    var stk = page && page.querySelector('.aew-sticky'); if (!stk) return;
    var hs = st.items.map(function (i) { return i.h; });
    Promise.all(hs.map(product)).then(function (ds) {
      // the same size and price each row shows (their size if in stock, else the smallest), so the total adds up
      var lines = ds.map(function (d, i) { return pickVar(d, st.items[i].s); }).filter(function (v) { return v && v.a; });
      if (!lines.length) { stk.hidden = true; return; }
      var tot = lines.reduce(function (a, v) { return a + v.p; }, 0);
      stk.hidden = false;
      stk.querySelector('button').textContent = t('bring_home', { total: money(tot) });
      stk.querySelector('p').textContent = lines.length === 1 ? t('bring_home_one') : t('bring_home_n', { n: lines.length });
      stk._lines = lines;
    });
  }
  if (page) {
    page.addEventListener('click', function (e) {
      var a = e.target.closest('[data-act]'), sw = e.target.closest('[data-look]');
      if (sw && sw.tagName === 'BUTTON') { setLook(sw.getAttribute('data-look')); return; }
      if (e.target.closest('[data-aew-save]')) { track('save_click'); return; }
      if (a && a.getAttribute('data-act') === 'allcol') { showAllCollected = true; renderPage(); return; }
      if (a && a.getAttribute('data-act') === 'home') {
        var stk = page.querySelector('.aew-sticky'); var lines = stk && stk._lines; if (!lines) return;
        a.disabled = true;
        addToBag(lines).then(function () { toast(lines.length === 1 ? t('home_added_one') : t('home_added', { n: lines.length })); a.disabled = false; }).catch(function () { a.disabled = false; toast(t('add_failed')); });
        return;
      }
      var row = e.target.closest('.aew-item, .aew-slot[data-h]'); if (!row) return;
      var h = row.getAttribute('data-h');
      var isCol = row.hasAttribute('data-col');
      var entry = isCol ? st.collected.filter(function (c) { return String(c.p) === row.getAttribute('data-col'); })[0] : st.items[has(row.getAttribute('data-p')) - 1];
      if (!entry) return;
      product(h).then(function (d) {
        if (!d) return;
        var act = a && a.getAttribute('data-act');
        if (act === 'out') return moveOut(entry.p, niceTitle(d.t, d.v));
        if (act === 'add') {
          var v = pickVar(d, entry.s); if (!v || !v.a) return openSheet(entry, d, 'almost');
          a.disabled = true;
          return addToBag([v]).then(function () { a.disabled = false; toast(t('added_bag', { name: esc(niceTitle(d.t, d.v)), size: esc(sizeLabel(v.t)) })); }).catch(function () { a.disabled = false; toast(t('add_failed')); });
        }
        openSheet(entry, d, isCol ? (act === 'bigger' ? 'bigger' : 'collected') : 'almost');
      });
    });
  }

  // ---------- home page welcome back ----------
  var welcome = document.getElementById('aew-welcome');
  function renderWelcome() {
    if (!welcome) return;
    var items = st.items;
    if (!items.length) { welcome.hidden = true; welcome.innerHTML = ''; return; }
    // counts and bottles cover in-stock scents only, so the numbers match what one tap can bring home
    Promise.all(items.map(function (it) { return product(it.h); })).then(function (ds) { drawWelcome(items.filter(function (it, i) { return avail(ds[i]); })); });
  }
  function drawWelcome(items) {
    if (!items.length) { welcome.hidden = true; welcome.innerHTML = ''; return; }
    welcome.hidden = false;
    var first = C.firstName ? esc(C.firstName) : '';
    var show = items.slice(-4);
    var html = '<div class="aew-welcome__in" data-look="' + st.look + '"><div class="aew-welcome__text"><div class="aew-eyebrow">' + (first ? t('welcome_named', { name: first }) : esc(t('welcome'))) + '</div>' +
      '<h2 class="aew-h3">' + esc(t('welcome_title')) + '</h2><p>' + esc(items.length === 1 ? t('welcome_body_one') : t('welcome_body_n', { n: items.length })) + '</p></div>' +
      '<div class="aew-cabinet aew-cabinet--mini">' + frame() + '<div class="aew-wlabel"><span>' + esc(t('almost_yours_n', { n: items.length })) + '</span></div><div class="aew-shelf aew-shelf--four">';
    show.forEach(function (it) { html += '<a class="aew-slot" href="' + esc(C.wardrobeUrl) + '" data-h="' + esc(it.h) + '"><span class="aew-card aew-card--loading">' + CORNERS + '</span></a>'; });
    for (var i = show.length; i < 4; i++) html += '<div class="aew-slot aew-slot--blank"></div>';
    html += '</div><div class="aew-plank"></div></div><a class="aew-btn aew-btn--big" href="' + esc(C.wardrobeUrl) + '">' + esc(t('open_wardrobe')) + '</a></div>';
    welcome.innerHTML = html;
    welcome.querySelectorAll('.aew-slot[data-h]').forEach(function (s) {
      product(s.getAttribute('data-h')).then(function (d) { var c = s.querySelector('.aew-card'); if (c) c.outerHTML = card(d, d ? niceTitle(d.t, d.v) : ''); });
    });
  }

  function renderAll() { renderPage(); renderWelcome(); paintButtons(); }
  onChange(function () { renderPage(); renderWelcome(); });

  // ---------- sign-in: load from the account, merge the device wardrobe ----------
  function refresh(fresh) {
    return serverGet(fresh).then(function (j) {
      if (!j || j.signedIn === false) {
        if (st.signedIn) signedOut();
        return;
      }
      var guest = lsGet(LS_KEY);
      var guestItems = (guest && guest.items) || [];
      if (guestItems.length) {
        // move the device wardrobe into the account; clear the device copy only once the server has it
        var body = 'payload=' + encodeURIComponent(JSON.stringify({ ops: [{ op: 'merge', guest: { items: guestItems, look: guest.look || st.look } }], events: [] })) + '&c=' + encodeURIComponent(C.c || '') + '&t=' + encodeURIComponent(C.t || '');
        return fetch(C.proxy, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' }, body: body })
          .then(function (r) { if (!r.ok) throw new Error('merge ' + r.status); return r.json(); })
          .then(function (m) {
            if (m && m.items && guestItems.every(function (g) { return m.items.some(function (i) { return String(i.p) === String(g.p); }) || m.collected.some(function (c) { return String(c.p) === String(g.p); }); })) {
              try { localStorage.removeItem(LS_KEY); } catch (e) {}
              adopt(m);
              toast(guestItems.length === 1 ? t('merged_one') : t('merged', { n: guestItems.length }));
            } else adopt(j);
          })
          .catch(function () { adopt(j); });
      }
      if (j.justCollected && j.justCollected.length) {
        justCollected = j.justCollected.map(String);
        setTimeout(function () { var cn = (j.collected || []).length; toast(cn === 1 ? t('collected_toast_one') : t('collected_toast', { n: cn })); }, 600);
      }
      adopt(j);
    }).catch(function () {});
  }

  // first paint from cache/device, then the account
  if (welcome) { var stored = lsGet(LOOK_KEY); if (stored) st.look = stored; }
  renderAll();
  if (page) track('view');
  // Ask the account on the wardrobe page always; on the home page and elsewhere only for (likely)
  // signed-in visitors (elsewhere at most every 10 minutes). Guests outside the wardrobe page never call.
  var lastSync = ssGet('aew-sync') || 0;
  if (page || ((C.c || st.signedIn) && (welcome || Date.now() - lastSync > 10 * 60 * 1000))) {
    ssSet('aew-sync', Date.now());
    refresh(!!page);
  }
  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.AEWardrobe = { has: has, hang: hang, state: function () { return st; } };
})();
